import React, { useContext } from 'react';
import { GenericEventType } from '@features/Calendar/constants';
import { useForm, FormProvider } from 'react-hook-form';
import { TimeZoneContext } from '@contexts/timezone-context';
import { EditGenericEventModalContext } from '../context/EditGenericEventModalContext';
import BasicInformationSection from './BasicInformationSection';
import DetailsSection from './DetailsSection';
import AdvancedSection from './AdvancedSection';
import Footer from './Footer';
function Form() {
    var _a, _b, _c, _d, _e;
    const { genericEvent } = useContext(EditGenericEventModalContext);
    const { timezone, timeZonesMapping } = useContext(TimeZoneContext);
    const useFormMethods = useForm({
        mode: 'onChange',
        defaultValues: {
            id: genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.id,
            title: (genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.title) || '',
            description: (genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.description) || '',
            address: (genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.address) || '',
            contactName: (genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.contactName) || '',
            contactPhone: (genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.contactPhone) || '',
            eventType: (genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.eventType) || GenericEventType.On_call,
            durationMins: (genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.durationMins) || 120,
            technicianIds: (genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.technicianIds) || [],
            timeZone: (genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.timeZone) ||
                Object.fromEntries(Object.entries(timeZonesMapping).map((entry) => entry.reverse()))[timezone],
            start: (_a = genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.start) === null || _a === void 0 ? void 0 : _a.tz(timeZonesMapping[genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.timeZone]),
            end: (_b = genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.end) === null || _b === void 0 ? void 0 : _b.tz(timeZonesMapping[genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.timeZone]),
            allDay: (_c = genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.allDay) !== null && _c !== void 0 ? _c : false,
            conflictable: (_d = genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.conflictable) !== null && _d !== void 0 ? _d : true,
            isRecurring: (_e = genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.isRecurring) !== null && _e !== void 0 ? _e : false,
            recurrence: (genericEvent === null || genericEvent === void 0 ? void 0 : genericEvent.recurrence) || {}
        }
    });
    const { watch, formState: { isValid, dirtyFields } } = useFormMethods;
    const formValues = watch();
    const isDirty = Object.keys(dirtyFields).length > 0;
    const showFooter = formValues.isRecurring && isDirty && isValid;
    return (React.createElement(FormProvider, Object.assign({}, useFormMethods),
        React.createElement("div", { className: "dialog__contain" },
            React.createElement(BasicInformationSection, null),
            React.createElement("hr", { className: "dialog__split splitSections" }),
            React.createElement(DetailsSection, null),
            React.createElement("hr", { className: "dialog__split splitSections" }),
            React.createElement(AdvancedSection, null)),
        showFooter && React.createElement(Footer, null)));
}
export default Form;
